const NotFoundView = () => {
  return ( 
    <div>404 Not Found</div>
  );
}
 
export default NotFoundView;